import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  makeStyles,
  TableContainer,
  Box
} from '@material-ui/core';
import numeral from 'numeral';

const useStyles = makeStyles(theme => ({
  root: {
    '&:nth-child(even)': {
      backgroundColor: '#F2F2F2'
    }
  },
  dialogContent: {
    padding: 0
  }
}));

const CostDetails = ({
  open,
  handleClose,
  productDetails,
  pixDetails,
  warehouseList = []
}) => {
  const classes = useStyles();
  if (!open) return null;

  const isFldVisible = fld => {
    for (let index = 0; index < pixDetails.length; index++) {
      const item = pixDetails[index];
      if (Object.keys(item).includes(fld)) {
        return true;
      }
    }

    return false;
  };

  const getWarehouseDescription = id => {
    const idx = warehouseList.findIndex(data => data.ixWH === id);

    if (idx === -1) return '';

    return warehouseList?.[idx]?.sWH ?? '';
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
      <DialogTitle disableTypography>
        <Typography variant="h4" color="textSecondary">
          {productDetails.sProd}
        </Typography>
      </DialogTitle>

      <DialogContent
        dividers
        classes={{
          root: classes.dialogContent
        }}
      >
        {pixDetails.length === 0 && (
          <Box p={3}>
            <Typography variant="h4" align="center" color="textSecondary">
              No data to show!
            </Typography>
          </Box>
        )}

        {pixDetails.length > 0 && (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {isFldVisible('ixRowGrp') && (
                    <TableCell>Row Grp ID</TableCell>
                  )}
                  <TableCell>Product Code</TableCell>
                  <TableCell>Product ID</TableCell>
                  {isFldVisible('ixTrans') && <TableCell>Trans. ID</TableCell>}
                  {isFldVisible('six') && <TableCell>six</TableCell>}
                  {isFldVisible('pix') && <TableCell>pix</TableCell>}
                  {isFldVisible('ixWH') && <TableCell>Warehouse</TableCell>}
                  {isFldVisible('qty') && (
                    <TableCell align="right">Qty</TableCell>
                  )}
                  {isFldVisible('cost') && (
                    <TableCell align="right">Cost</TableCell>
                  )}
                  {isFldVisible('salesCost') && (
                    <TableCell align="right">Sales Cost</TableCell>
                  )}
                  {isFldVisible('price') && (
                    <TableCell align="right">Price</TableCell>
                  )}
                  {isFldVisible('qtyIN') && (
                    <TableCell align="right">IN</TableCell>
                  )}

                  {isFldVisible('priceIN') && (
                    <TableCell align="right">Price IN</TableCell>
                  )}

                  {isFldVisible('vatIN') && (
                    <TableCell align="right">VAT IN</TableCell>
                  )}

                  {isFldVisible('qtyOUT') && (
                    <TableCell align="right">OUT</TableCell>
                  )}
                  {isFldVisible('priceOUT') && (
                    <TableCell align="right">Price OUT</TableCell>
                  )}
                  {isFldVisible('vatOUT') && (
                    <TableCell align="right">VAT IN</TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {pixDetails.map((data, i) => (
                  <TableRow className={classes.root} hover key={i}>
                    {isFldVisible('ixRowGrp') && (
                      <TableCell>{data.ixRowGrp}</TableCell>
                    )}
                    <TableCell>{productDetails?.ProdCd ?? ''}</TableCell>
                    <TableCell>{productDetails?.ixProd ?? ''}</TableCell>
                    {isFldVisible('ixTrans') && (
                      <TableCell>{data.ixTrans}</TableCell>
                    )}
                    {isFldVisible('six') && <TableCell>{data.six}</TableCell>}
                    {isFldVisible('pix') && <TableCell>{data.pix}</TableCell>}
                    {isFldVisible('ixWH') && (
                      <TableCell>
                        {getWarehouseDescription(data.ixWH)}
                      </TableCell>
                    )}
                    {isFldVisible('qty') && (
                      <TableCell align="right">
                        {numeral(data.qty).format('#,###.##')}
                      </TableCell>
                    )}
                    {isFldVisible('cost') && (
                      <TableCell align="right">
                        {numeral(data.cost).format('#,###.####')}
                      </TableCell>
                    )}
                    {isFldVisible('salesCost') && (
                      <TableCell align="right">
                        {numeral(data.salesCost).format('#,###.####')}
                      </TableCell>
                    )}
                    {isFldVisible('price') && (
                      <TableCell align="right">
                        {numeral(data.price).format('#,###.####')}
                      </TableCell>
                    )}
                    {isFldVisible('qtyIN') && (
                      <TableCell align="right">
                        {numeral(data.qtyIN).format('#,###.##')}
                      </TableCell>
                    )}
                    {isFldVisible('priceIN') && (
                      <TableCell align="right">
                        {numeral(data.priceIN).format('#,###.####')}
                      </TableCell>
                    )}
                    {isFldVisible('vatIN') && (
                      <TableCell align="right">
                        {numeral(data.vatIN).format('#,###.####')}
                      </TableCell>
                    )}

                    {isFldVisible('qtyOUT') && (
                      <TableCell align="right">
                        {numeral(data.qtyOUT).format('#,###.##')}
                      </TableCell>
                    )}

                    {isFldVisible('priceOUT') && (
                      <TableCell align="right">
                        {numeral(data.priceOUT).format('#,###.####')}
                      </TableCell>
                    )}
                    {isFldVisible('vatOUT') && (
                      <TableCell align="right">
                        {numeral(data.vatOUT).format('#,###.####')}
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CostDetails;
